<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container">
            <a class="navbar-brand" href="#">
                <img :src="logo" alt="">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarScroll" aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarScroll">
                <ul class="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll" style="--bs-scroll-height: 100px;">
                    <li class="nav-item">
                        <router-link to="/catalogo">Catálogo</router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <router-link to="/puntosEntrega">Puntos de Entrega</router-link>
                    </li> -->
                    <li class="nav-item">
                        <router-link to="/encuestas">Encuestas</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/preventas">Preventas</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/descuentos">Descuentos</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
   
    data(){
        return{
            //logo: require("@/assets/funko-morelia-logo.jpeg")
            logo: require("@/assets/funko-logo-white.svg")
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .navbar {
        margin-bottom: 10px;
        padding: 10px 0;
        @media (min-width: 768px){
             margin-bottom: 50px;
        }
       
        .router-link-exact-active {
            color: green;
        }
        &-brand {
            img {
                width: 30px;
                @media (min-width: 768px){
                    width: 50px;
                    height: auto;
                }
            }
        }
        .nav-item{
            margin: 0 30px;;
            a{
                color: #FFF;
                text-decoration: none;
                text-transform: uppercase;
                font-weight: bold;
            }
        }
    }
</style>